import { render, staticRenderFns } from "./RsxTable.vue?vue&type=template&id=314bab53&scoped=true"
import script from "./RsxTable.vue?vue&type=script&lang=js"
export * from "./RsxTable.vue?vue&type=script&lang=js"
import style0 from "./RsxTable.vue?vue&type=style&index=0&id=314bab53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314bab53",
  null
  
)

export default component.exports